<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/*引入PingFang.css文件*/
@import '../src/assets/font/PingFang.css';
/*引入common.css文件*/
@import '../src/assets/common/css/common.css';
</style>
<style lang="scss">
/*引入公共弹出框样式*/
@import 'assets/common/css/popUp.scss';
@import 'assets/common/css/coupon.scss';
@import 'assets/common/css/base.scss';
@import 'assets/common/css/main.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue